import makeStyles from '@ui/utils/makeStyles';

export default makeStyles()((theme) => ({
  container: {
    width: 333,
    padding: 16,
    backgroundColor: '#f6f6f7',
    borderRadius: theme.shape.borderRadius,
    boxSizing: 'border-box',
    [theme.breakpoints.up('md')]: {
      width: 1142,
      height: 388,
      padding: 45,
      position: 'relative',
      marginTop: 47,
      display: 'flex',
      flexDirection: 'column',
    }
  },
  imageWrapper: {
    height: 200,
    width: '100%',
    position: 'relative',
    overflow: 'hidden',
    borderRadius: theme.shape.borderRadius,
    [theme.breakpoints.up('md')]: {
      position: 'absolute',
      right: 33,
      bottom: 39,
      width: 567,
      height: 396,
    }
  },
  image: {
    borderRadius: theme.shape.borderRadius,
    objectFit: 'cover',
    width: '100%',
    overflow: 'hidden',
  },
  likeButton: {
    position: 'absolute',
    bottom: 16,
    right: 16,
    backgroundColor: '#FFFFFF',
    [theme.breakpoints.up('md')]: {
      bottom: 31,
      right: 42,
    },
    '&:hover': {
      backgroundColor: '#FFFFFF'
    }
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    [theme.breakpoints.up('md')]: {
      width: 408,
      minHeight: 0,
    }
  },
  address: {
    margin: theme.spacing(1, 0, 2),
    color: '#080808',
    [theme.breakpoints.up('md')]: {
      margin: theme.spacing(0, 0, 2),
    }
  },
  realtorInfo: {
    marginTop: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
  },
  realtor: {
    fontSize: 14,
    lineHeight: '1.71',
    color: '#161d1e',
  },
  realtorIcon: {
    marginRight: 7,
  },
  button: {
    marginTop: theme.spacing(3),
    width: '100%',
    fontSize: 16,
    [theme.breakpoints.up('md')]: {
      height: 44,
      width: 215,
      marginTop: 'auto',
    }
  }
}));
